import SystemFieldProto from '../../proto/system-field-proto';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateTimeComponent from "../components/aggregate-time";
import TimeReportsCollection from "../../../model2/time-report/collection";

export default class TimeReportedField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.TIME_REPORTED;
        this.valueType = gd.const.fields.valueType.FLOAT;
        this.formulaCompatible = true;
    }

    get sortHintMessage() {
        return 'Sort by reported time';
    }

    getCsvValue(item) {
        return item.reportedTime ;
    }

    getValue(item) {

        // sometime item has reportedTime (i.e. list)
        // sometime item has timeReports array
        // so we need support both

        if (item.reportedTime) return item.reportedTime

        if (item.timeReports) {

            if (item.timeReports instanceof TimeReportsCollection) {
                // i.e. list / table
                return item.timeReports.totalReportedTime
            } else {
                // used in task view
                // no reportedTime in task view, timeReports array instead
                return _.sum(_(item.timeReports).map(r=>{
                    if (r.reportedTime) return r.reportedTime
                    return 0
                }).compact().value())
            }

        }

        return 0
    }
    getFormulaValue(item) {return gd.utils.Time.roundHours(this.getValue(item))}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.reported.total || 0],
            directions: [sort]
        }
    }

    get AggregateComponent() {return AggregateTimeComponent.bind(null, this.getAggregateOptions());}
}